import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "¿Qué tipos de transformadores reparan?",
    a: "Trabajamos con transformadores tipo aceite, abarcando capacidades desde 5 kVA hasta más de 3000 kVA. Atendemos equipos monofásicos y trifásicos sumergidos en aceite mineral o vegetal.",
  },
  {
    q: "¿Ofrecen servicio de emergencia 24/7?",
    a: "Sí. Contamos con un equipo de respuesta para atender fallas críticas en menos de 4 horas dentro del área metropolitana de Bucaramanga, y desplazamientos planificados al resto de Santander.",
  },
  {
    q: "¿Qué pruebas realizan tras una reparación?",
    a: "Megger (resistencia de aislamiento), TTR (relación de transformación), Hipot, polaridad, vacío, corto circuito y, cuando aplica, análisis físico-químico del aceite dieléctrico. Entregamos protocolos firmados.",
  },
  {
    q: "¿El servicio cumple con la normativa colombiana?",
    a: "Todos nuestros procesos se ajustan al RETIE, NTC 818, NTC 819 y normativa aplicable. Trabajamos bajo lineamientos de SST y trabajo seguro en alturas.",
  },
  {
    q: "¿Atienden fuera de Santander?",
    a: "Sí. Aunque nuestra base de operaciones está en Bucaramanga, atendemos proyectos a nivel nacional, en especial para clientes industriales y operadores de red.",
  },
  {
    q: "¿La cotización del simulador es definitiva?",
    a: "Es un estimado de referencia basado en valores típicos del mercado para que tenga un orden de magnitud. La cotización final se confirma tras la inspección técnica del equipo.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#ff6b00]" />
            <span>Preguntas frecuentes</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter">
            Lo que debes saber antes de cotizar.
          </h2>
          <p className="text-[#a0aabf] mt-6 leading-relaxed">
            Si tienes dudas adicionales sobre tu transformador, escríbenos por
            WhatsApp y un técnico responde directamente.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5"
              >
                <AccordionTrigger className="font-display text-base lg:text-lg font-semibold hover:no-underline hover:text-[#ff6b00] py-6 text-left">
                  <span className="flex items-center gap-4">
                    <span className="font-mono text-xs text-[#ff6b00]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#a0aabf] text-base leading-relaxed pb-6 pl-9">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
